import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import type { NavItem } from '../../../config/navigation';
import { isActivePath } from '../../../utils/navigation';

interface NavDropdownProps {
  items: NavItem[];
  onClose: () => void;
}

const NavDropdown: React.FC<NavDropdownProps> = ({ items, onClose }) => {
  const location = useLocation();

  return (
    <div className="absolute top-full left-0 mt-1 w-56 bg-white rounded-lg shadow-lg border border-border py-1.5 z-50 animate-slide-down">
      {items.map((item) => {
        const active = isActivePath(item.href, location.pathname);
        return (
          <Link
            key={item.href}
            to={item.href}
            onClick={onClose}
            className={`block px-4 py-2.5 transition-colors ${
              active
                ? 'text-brand bg-brand-light'
                : 'text-text-secondary hover:text-brand hover:bg-surface-1'
            }`}
          >
            <span className="text-sm font-medium">{item.label}</span>
            {item.description && (
              <span className="block text-xs text-text-tertiary mt-0.5">
                {item.description}
              </span>
            )}
          </Link>
        );
      })}
    </div>
  );
};

export { NavDropdown };
